<template lang="html">
    <div class="row">
        <div v-for="(item, idx) in data" :key="idx" class="col-12 col-md-6 mt-4">
            <CardMember
                :imageURL="baseUrlStorage+item.image"
                :title="item.title"
                :description="item.description"
            />
        </div>
    </div>
</template>
<script>
import CardMember from "./CardMember.vue"
export default {
    inject: ['baseUrlStorage'],
    props:{
        data:Array
    },
    components: {
        CardMember
    },
    data() {
        return {
            partners1: [
                {
                    imageURL: "https://i.ibb.co/MS0QqVx/Image-Banner-Home01.png",
                    title: "Lorem ipsum",
                    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit,"
                },
                {
                    imageURL: "https://i.ibb.co/X5FPHvQ/Image-Banner-Home02.png",
                    title: "Lorem ipsum",
                    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit,"
                },
                {
                    imageURL: "https://i.ibb.co/LzS8830/Image-Banner-Home03.png",
                    title: "Lorem ipsum",
                    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit,"
                },
                {
                    imageURL: "https://i.ibb.co/10P2Bwb/Image-Banner-Home04.png",
                    title: "Lorem ipsum",
                    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit,"
                },
                {
                    imageURL: "https://i.ibb.co/jZWzKh5/Image-Banner-Home05.png",
                    title: "Lorem ipsum",
                    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit,"
                },
                {
                    imageURL: "https://i.ibb.co/QdQc1dw/Image-Banner-Home06.png",
                    title: "Lorem ipsum",
                    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit,"
                },
            ]
        }
    },
}
</script>
<style lang="css">
</style>